import axiosInstance from '../utils/axios';

// Функции для работы с API аутентификации
const authService = {
  // Вход в систему
  login: async (username, password) => {
    try {
      const response = await axiosInstance.post('auth/login', { username, password });
      
      // Сохраняем токен и имя пользователя в localStorage
      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('username', response.data.user.username);
        localStorage.setItem('role', response.data.user.role);
      }
      
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Ошибка входа');
    }
  },

  // Регистрация
  register: async (username, password) => {
    try {
      const response = await axiosInstance.post('auth/register', { username, password });
      
      // Если регистрация успешна, можно сразу авторизовать пользователя
      if (response.data.success && response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('username', username);
      }
      
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Ошибка регистрации');
    }
  },

  // Получение данных текущего пользователя
  getCurrentUser: async () => {
    try {
      // Проверяем наличие токена
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Пользователь не авторизован');
      }
      
      // Запрос к API для получения данных пользователя
      const response = await axiosInstance.get('auth/me');
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Ошибка получения данных пользователя');
      }
    } catch (error) {
      // Если запрос не удался, возвращаем данные из localStorage как запасной вариант
      const username = localStorage.getItem('username');
      const role = localStorage.getItem('role');
      if (username && role) {
        return { username, role };
      }
      
      throw new Error(error.response?.data?.error || 'Ошибка получения данных пользователя');
    }
  },

  updatePanelPalette: async (panelPalette) => {
    try {
      const response = await axiosInstance.patch('auth/me/palette', { panelPalette });
      if (!response.data.success || !response.data.data?.panelPalette) {
        throw new Error('Не удалось сохранить палитру');
      }
      return response.data.data.panelPalette;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Не удалось сохранить палитру');
    }
  },

  updatePanelBackground: async (panelBackground) => {
    try {
      const response = await axiosInstance.patch('auth/me/background', { panelBackground });
      if (!response.data.success || !response.data.data?.panelBackground) {
        throw new Error('Не удалось сохранить фон');
      }
      return response.data.data.panelBackground;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Не удалось сохранить фон');
    }
  },

  updatePanelTextColor: async (panelTextColor) => {
    try {
      const response = await axiosInstance.patch('auth/me/text-color', { panelTextColor });
      if (!response.data.success || !response.data.data?.panelTextColor) {
        throw new Error('Не удалось сохранить цвет текста');
      }
      return response.data.data.panelTextColor;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Не удалось сохранить цвет текста');
    }
  },

  // Проверка валидности токена
  validateToken: async (token) => {
    try {
      if (!token) {
        return false;
      }
      
      // Проверяем токен, делая запрос к защищенному маршруту
      const response = await axiosInstance.get('auth/me');
      return response.data.success;
    } catch (error) {
      // Если получаем ошибку 401, значит токен недействителен
      if (error.response && error.response.status === 401) {
        // Удаляем недействительный токен из localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('role');
      }
      return false;
    }
  }
};

export default authService;
